import { FC } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import SelectFormutil from 'components/Formutil/SelectFormutil';
import { NameTypeEnum, SuffixEnum } from 'types/customer';
import FirstName from '../components/FirstName';
import LastName from '../components/LastName';
import MiddleInitial from '../components/MiddleInitial';
import { suffixOptions } from '../helper';
import { BaseRealNameInfoProps } from '../type';

const USA: FC<BaseRealNameInfoProps> = ({ disabled }) => {
    return (
        <div>
            <FirstName disabled={disabled} />
            <MiddleInitial disabled={disabled} />
            <LastName disabled={disabled} />
            <SelectFormutil
                label={__('Suffix')}
                name="suffix"
                $defaultValue={SuffixEnum.None}
                selectProps={{
                    placeholder: __('Please Select'),
                    options: suffixOptions,
                    disabled
                }}
            />
            <EasyField name="name_type" $defaultValue={NameTypeEnum.USA} type="hidden" />
        </div>
    );
};

export default USA;
